module.exports = __webpack_public_path__ + "img/BOTIQUINES.8ea6487b.png";